import { getPositionBriqueRapport } from '@/scripts/global.js';
import { 
	apiDeplacerBriquesRapport,
	apiAfficherTypeObjetDansBriqueRapport,
	apiAfficherChampsDansBriqueRapport } from '@/services/ServiceModele.js';

export function getAppelApiGlisserDeplacer(event, element, elementParent) {
	const donneesTransfert = JSON.parse(event.dataTransfer.getData('text/plain'));
	switch(donneesTransfert.type) {
		case 'DEPLACEMENT_BRIQUES': {
			const positionBriqueDestination = getPositionBriqueRapport(element, elementParent);
			const infosDeplacement = {
				positionsBriquesDeplacees: donneesTransfert.positionsBriquesDeplacees, 
				positionBriqueDestination
			};
			return {api: apiDeplacerBriquesRapport, argument: infosDeplacement};
		}
		case 'TYPE_OBJET': {
			const positionBriqueDestination = getPositionBriqueRapport(element, elementParent);
			const infoBriqueRapport = {
				positionBrique: positionBriqueDestination, 
				texte: donneesTransfert.typeObjet.nom
			};
			return {api: apiAfficherTypeObjetDansBriqueRapport, argument: infoBriqueRapport};
		}
		case 'CHAMPS': {
			const positionBriqueDestination = getPositionBriqueRapport(element, elementParent);
			const idChamps = donneesTransfert.champs.map(champ => champ.id);
			const idTypeObjet = donneesTransfert.champs[0].idTypeObjet;
			const infosAffichageChamps = {
				positionBrique: positionBriqueDestination, 
				idTypeObjet: idTypeObjet,
				idChamps: idChamps
			};
			return {api: apiAfficherChampsDansBriqueRapport, argument: infosAffichageChamps};
		}
	}
	return null;
}